import React from "react"
import { graphql } from "gatsby"

import GenericImageCarousel from "../../molecules/GenericImageCarousel"

import * as Utils from "./utils"

const ImageTextCarousel = ({
  section,
  ITCSectionTitle,
  sectionTitle,
  card,
  ITCCard,
  ...props
}) => {
  sectionTitle = ITCSectionTitle || sectionTitle
  card = ITCCard || card
  const {
    verticalPadding,
    items,
    overlap,
    controlsLocation,
    mediaPositioning,
    conditionalProps,
    isMediaPositioningFloating,
    customPadding,
    // imageTextMoleculeProps,
  } = Utils.useMemoizedProps({ section, sectionTitle, card, ...props })

  const imageTextMoleculeProps = {
    align: props.imageTextCarouselAlign || props.align,
    card: props.card,
    child1Px: props.child1Px,
    layoutStyle: props.imageTextCarouselLayoutStyle || props.layoutStyle,
    location: props.imageTextCarouselTextLocation || props.location,
    mediaLocation: props.mediaLocation || props.imageTextCarouselMediaLocation,
    mediaPositioning,
    mediaPositioningOnMobile:
      props.imageTextCarouselMediaPositioningOnMobile ||
      props.mediaPositioningOnMobile,
    mediaRatio: props.mediaRatio,
    xOffsetOverlap: props.xOffsetOverlap,
    yOffsetOverlap: props.yOffsetOverlap,
    overlapOnMobile: true,
    // child2Style:props.child2Style
    // child1Style:props.child1Style
    // section:props.section,
  }

  const child1Style = {}
  const child2Style = {}

  const standardPaddingStyles = {}
  const layoutChangerStyles = {}

  // Grow the slide to full height for FIT so media can fill the column
  if (imageTextMoleculeProps.mediaPositioning === "fit") {
    layoutChangerStyles.height = { _: "100%", md: "100%" }
  }

  const layoutType = Utils.getLayoutType(imageTextMoleculeProps.location)
  const alignProp = imageTextMoleculeProps.align || "start"
  const justifyContentMap = {
    start:
      imageTextMoleculeProps.location === "top" ? "flex-start" : "flex-end",
    center: "center",
    end: imageTextMoleculeProps.location === "top" ? "flex-end" : "flex-start",
  }
  if (imageTextMoleculeProps.mediaPositioning === "floating") {
    // Vertically center the whole floating block while letting the text start at the top
    layoutChangerStyles.alignItems = { _: "stretch", md: "stretch" }
    layoutChangerStyles.justifyContent = { _: "flex-start", md: "center" }
    child2Style.maxHeight = { _: "300px", lg: "400px" }
    child2Style.alignSelf = { _: "stretch", md: "inherit" }
    if (layoutType === "adjacent") {
      // Make the TEXT COLUMN fill available height so controls can anchor to its bottom
      child1Style.display = { _: "flex", md: "flex" }
      child1Style.flexDirection = { _: "column", md: "column" }
    } else if (layoutType === "stacked") {
      layoutChangerStyles.justifyContent = justifyContentMap[alignProp]
    }
  } else {
    // Non-floating / "fit" and others
    standardPaddingStyles.px = { _: 5, md: 7, xl: 4 }

    if (section.verticalPadding === "fullHeight") {
      layoutChangerStyles.height = { _: "100%", md: "100vh" }
    }
    if (overlap) {
      child2Style.maxHeight = { _: "335px", md: "100%" }
      child1Style.pb = { _: 0, md: "100px" } //adding padding btw controls and text (for fit positioning - desktop layout)
    } else {
      child2Style.maxHeight = { _: "400px", sm: "600px", md: "100%" }
      child1Style.pb = { _: 0, sm: "25px", md: "60px" } //adding padding btw controls and text (for fit positioning - desktop layout)
    }
    // Keep the text column anchored to the top on non-floating adjacent layouts to prevent jumping
    if (layoutType === "adjacent") {
      child1Style.alignSelf = { _: "flex-start", md: "flex-start" }
    } else if (layoutType === "stacked") {
      layoutChangerStyles.justifyContent = justifyContentMap[alignProp]
    }
  }

  standardPaddingStyles.maxWidth = "100%"

  const sectionProp = { ...section, verticalPadding }
  return (
    <GenericImageCarousel
      sectionTitle={sectionTitle}
      items={items}
      section={sectionProp}
      carouselType="imageText"
      // mediaLocation={"right"}
      // mediaLocation={
      //   props.mediaLocation || props.imageTextCarouselMediaLocation
      // }
      showMedia={props.showMedia}
      controlsLocation={controlsLocation}
      controlsAlignment={
        props.controlsAlignment || props.imageTextCarouselControlsAlignment
      }
      controls={props.showArrows}
      indicators={props.showIndicators}
      rotateSpeed={props.rotateSpeed}
      textAlign={props.textAlign || props.imageTextCarouselTextAlign}
      imageTextMolecule={{
        // ...props, //maybe this can be removed
        ...imageTextMoleculeProps,
        section: sectionProp,
        layoutChangerStyles,
        standardPaddingStyles,
        child2Style,
        child1Style,

        // ...imageTextMoleculeProps,
        //-----------------------
        // customPadding,
        // conditionalProps,
        // isMediaPositioningFloating,
        // overlap,
        // childrenStyles,
        // standardPaddingProps,
        // renderSectionTitle,
        // hasImageOrVideo,
        // renderImageOrVideo,
        // alignProp: "start",
        // ------------
      }}
    />
  )
}

export default React.memo(ImageTextCarousel)

export const query = graphql`
  fragment ImageTextCarousel on STRAPI__COMPONENT_SECTIONS_IMAGE_TEXT_CAROUSEL {
    strapi_id
    IMAGETEXTCAROUSELSection: section {
      ...Section
    }
    ITCSectionTitle: sectionTitle {
      ...SectionTitle
    }
    items {
      ...ImageTextCarouselItem
    }
    ITCCard: card {
      ...Card
    }
    imageOrVideoStyle {
      controls
      light
      playing
      loop
      volume
    }
    iconStyles {
      ...IconStyles
    }
    imageTextCarouselControlsLocation: controlsLocation
    imageTextCarouselControlsAlignment: controlsAlignment
    showMedia
    showArrows
    showIndicators
    imageTextCarouselTextAlign: textAlign
    rotateSpeed
    child1Px
    imageTextCarouselAlign: align
    imageTextCarouselTextLocation: location
    imageTextCarouselLayoutStyle: layoutStyle
    imageTextCarouselMediaLocation: mediaLocation
    imageTextCarouselMediaPositioning: mediaPositioning
    imageTextCarouselMediaPositioningOnMobile: mediaPositioningOnMobile
    mediaRatio
    xOffsetOverlap
    yOffsetOverlap
  }
`
